(function () {
  'use strict';

  /* @ngdoc object
   * @name login
   * @description
   *
   */
  angular
    .module('auth.login', [
      'ui.router',
      'auth.impersonation'
    ]);
}());
